




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNIPROFILEGETBYID= createAsyncThunk(
  "AlumniProfileGetById/AlumniProfileGetById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AlumniProfileGetByIdSlice = createSlice({
  name: "AlumniProfileGetByIdSlice",
  initialState: {
    AlumniProfileGetById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAlumniProfileGetById: (state) => {
        state.AlumniProfileGetById.loading = false
        state.AlumniProfileGetById.error = false
        state.AlumniProfileGetById.data = []
        state.AlumniProfileGetById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNIPROFILEGETBYID.fulfilled, (state, action) => {
      state.AlumniProfileGetById = {
        ...state.AlumniProfileGetById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIPROFILEGETBYID.pending, (state, action) => {
      state.AlumniProfileGetById = {
        ...state.AlumniProfileGetById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIPROFILEGETBYID.rejected, (state, action) => {
      state.AlumniProfileGetById = {
        ...state.AlumniProfileGetById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AlumniProfileGetByIdAction = {
    ALUMNIPROFILEGETBYID,
};

export { AlumniProfileGetByIdAction };
export default AlumniProfileGetByIdSlice.reducer;
export const {setInitialStateOfAlumniProfileGetById} = AlumniProfileGetByIdSlice.actions
